export enum LocationOfCareTypeEnum {
  Home = 1,
  Facility = 2,
  ContactsResidence = 3
}

export const LocationOfCareTypeOptions = [
{ id: 1, label: 'Home' },
{ id: 2, label: 'Facility' },
{ id: 3, label: 'Contact\'s Residence' }
];
